import classNames from "classnames";
import { isTerminalBuildState, BuildStates } from "~/constants/BuildStates";
import { CommandJob, TriggerJob } from "~/components/build/Show/lib/types";
import { useSteps } from "~/components/build/Show/lib/useSteps";

interface Props {
  job: CommandJob | TriggerJob;
  build: {
    state: BuildStates;
  };
}

export const MissingDependenciesNode = (props: Props) => {
  const { stepsMap } = useSteps();

  const missingGroupDependencies = props.job.groupUuid
    ? stepsMap.get(props.job.groupUuid)?.missingDependencies || []
    : [];

  if (!props.job.missingDependencies?.length && !missingGroupDependencies?.length) {
    return null;
  }

  const isBuildTerminal = isTerminalBuildState(props.build.state);
  const missingDependenciesMessage =
    missingGroupDependencies?.length > 0
      ? "Group step dependencies not found"
      : "Step dependencies not found";

  return (
    <div
      className={classNames("job-stats flex-none max-md:sr-only", {
        "rounded bg-orange-500/[0.18] px-1 !text-orange-800": !isBuildTerminal,
      })}
    >
      <span>
        {isBuildTerminal ? missingDependenciesMessage : "Waiting on unresolved dependencies"}
      </span>
    </div>
  );
};
